/*@flow*/
import isType from './isType';
import getFunctionName from './getFunctionName';
import assert from './assert';
import stringify from './stringify';
import type { TypeT } from './types';

// creates an instance of a type, handling the optional new operator
export default function create(
  type: TypeT<*>,
  value: any,
  path?: string[] | null
): any {
  if (isType(type)) {
    return !type.meta.identity && typeof value === 'object' && value !== null
      ? new type(value, path) //eslint-disable-line
      : type(value, path);
  }
  let path1 = path || [getFunctionName(type)];

  if (process.env.NODE_ENV !== 'production') {
    // here type should be a class constructor and value some instance, just check membership and return the value
    assert(value instanceof type, function() {
      return (
        'Invalid value ' + stringify(value) + ' supplied to ' + path1.join('/')
      );
    });
  }

  return value;
}
